<template>
  <span>
    <BotPageTitle />
    <h3
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }"
      style="margin-top: 0; margin-bottom: 20px; padding: 0 15px;"
    >
      Workspaces
    </h3>
    <div class="md-layout" style="padding-left: 20px;">
      <div class="md-layout-item">
        <v-row>
          <v-col
            xl="3"
            lg="4"
            md="6"
            sm="12"
            xs="12"
            v-for="(workspace, i) in workspaces"
            :key="i"
          >
            <WorkspacesCard
              :workspace="workspace"
              :active="!!active && workspace.id === active.id"
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </span>
</template>

<script>
import BotPageTitle from '@/components/BotPageTitle.vue'
import WorkspacesCard from '@/components/WorkspacesCard'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'Workspaces',
  components: {
    BotPageTitle,
    WorkspacesCard
  },
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    ...mapGetters('workspaces', ['workspaces', 'active'])
  },
  created () {
    // console.log('created da workspaces.vue')
    this.$store.dispatch('workspaces/populate')
    // if (typeof this.assistantData?.data?.name === typeof undefined) {
    //   this.$router.push('/lista-assistentes')
    // }
  }
}
</script>

<style scoped>
/* .md-button.md-warning.access-workspace {
  background-color: #e0e0e0 !important;
} */
.md-button .access-workspace {
  background-color: #e0e0e0 !important;
}
.md-button .access-workspace:hover,
.md-button .access-workspace:focus,
.md-button .access-workspace:active,
.md-button .access-workspace.active,
.md-button .access-workspace:active:focus,
.md-button .access-workspace:active:hover,
.md-button .access-workspace.active:focus,
.md-button .access-workspace.active:hover {
  background-color: #e0e0e0 !important;
  color: #fff !important;
  -webkit-box-shadow: 0 14px 26pxnode -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
  box-shadow: 0 14px 26px -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
}
</style>
